import React from "react";

import parse from "html-react-parser";
import { Table } from "react-bootstrap";

import {
    defaultDateFormat,
    defaultDateTimeFormat,
} from "../../../../lib/utils";
import { IGameLog } from "../../../../types/api";

const GameLogTable = ({ data }: { data: IGameLog[] }) => {
    return (
        <Table className="gameLogsTable" striped bordered responsive>
            <thead>
                <tr>
                    <th>Log Date</th>
                    <th>Game Date</th>
                    <th>Action</th>
                    <th>Description</th>
                    <th>User</th>
                </tr>
            </thead>
            <tbody>
                {data.map(l => {
                    return (
                        <tr key={l.id}>
                            <td width={"15%"}>
                                {defaultDateTimeFormat.format(new Date(l.date))}
                            </td>
                            <td width={"15%"}>
                                {defaultDateTimeFormat.format(
                                    new Date(l.game.date),
                                )}
                            </td>
                            <td width={"20%"}>{l.action}</td>
                            <td width={"35%"}>
                                {l.description && parse(l.description)}
                            </td>
                            <td width={"15%"}>
                                {`${l.user.meta.firstName} ${l.user.meta.lastName}`}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default GameLogTable;
